import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';

import setAutorizationToken from './utils/setAutorizationToken'; 
import MainRouter from './routers/MainRouter'; 
import { APP_FOLDER } from './keys'; 

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/ForgotPassword'));
const RestorePassword = React.lazy(() => import('./views/pages/restorePassword/RestorePassword'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Socios = React.lazy(() => import('./views/pages/socios/socios'));

setAutorizationToken(localStorage.token); 

class App extends Component {

  render() {
    return (
      <BrowserRouter basename={APP_FOLDER}>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/forgot/:socio?" name="Forgot Password" render={props => <ForgotPassword {...props}/>} />
              <Route exact path="/restore/:ID/:Token/:socio?" name="Restore Password" render={props => <RestorePassword {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route exact path="/socios/:socio?/:variant?/:message?" name="Login Socios Page" render={props => <Socios {...props}/>} />
              {/*<Route path="/" name="Home" render={props => <TheLayout {...props}/>} />*/}
              <MainRouter path="/" name="Home" component={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
